module.exports = {
    "sections": [
        {
            "name": "Net zero",
            "slug": "section-1",
            
            "questions": [
                {
                    "label": "Cory has committed to reaching net zero carbon emissions across its operations by 2040. Are you supportive of Cory’s plans to reach net zero through the use of carbon capture at Riverside?",
                    "number": "1",
                    "name": "01-question",
                    "type": "radio",

                    "options": [
                        {
                            "label": "Yes",
                            "value": "yes"
                        },
                        {
                            "label": "No",
                            "value": "no"
                        }
                    ],

                    "additional_questions": [
                        {
                            "label": "Any further comments?",
                            "name": "01-question-1",
                            "type": "text",
                            "number": "1"
                        }
                    ]
                }
            ]
        },
        {
            "name": "Design principles",
            "slug": "section-2",
            
            "questions": [
                {
                    "label": "Cory has developed four themes (people, place, value, climate) that will influence the design principles of our carbon capture proposals. Do you have any comments on these themes?",
                    "number": "2",
                    "name": "02-question",
                    "type": "text",
                }
            ]
        },
        {
            "name": "Land-based infrastructure",
            "slug": "section-3",
            
            "questions": [
                {
                    "label": `Cory will need to install CO<sub>2</sub> storage tanks as part of our carbon capture proposals. Decisions on the final design of these tanks, for example whether they are of a spherical or vertical design, will be influenced by a wide range of technical and environmental assessments. Do you have any comments on the two options for the design of these CO<sub>2</sub> storage tanks?`,
                    "number": "3",
                    "name": "03-question",
                    "type": "text",
                },
                {
                    "label": "Do you have any other comments on issues you feel should be addressed during the planning of the construction process?",
                    "number": "4",
                    "name": "04-question",
                    "type": "text",
                }
            ]
        },
        {
            "name": "River-based infrastructure",
            "slug": "section-4",
            
            "questions": [
                {
                    "label": "Cory believes there is an opportunity to preserve the Belvedere Power Station Jetty so that it could be used to protect and enhance local ornithology and heritage. If the project determines that this is possible, do you have any comments on how you would like to see this achieved?",
                    "number": "5",
                    "name": "05-question",
                    "type": "text",
                },
                {
                    "label": "Cory will need to install a new jetty to facilitate the off-site storage of the carbon we will capture. Do you have any comments on the new jetty we are proposing?",
                    "number": "6",
                    "name": "06-question",
                    "type": "text",
                }
            ]
        },
        {
            "name": "Environmental mitigation and enhancement opportunities",
            "slug": "section-5",
            
            "questions": [
                {
                    "label": "Do you have any comments on our on-site environmental mitigation area or how we could improve green spaces and habitats in the local area?",
                    "number": "7",
                    "name": "07-question",
                    "type": "text",
                },
                {
                    "label": "Do you have any comments on our plans to improve connectivity in the local area, specifically through enhancing and expanding public rights of way?",
                    "number": "8",
                    "name": "08-question",
                    "type": "text",
                }
            ]
        },
        {
            "name": "Other",
            "slug": "section-6",
            
            "questions": [
                {
                    "label": "Do you have any further comments on Cory’s decarbonisation proposals?",
                    "number": "9",
                    "name": "09-question",
                    "type": "text",
                }
            ]
        },
        {
            "name": "Your details",
            "slug": "your-details",

            "questions": [
                {
                    "label": "Name",
                    "name": "10-name",
                    "required": true,
                    "type": "text",
                    "placeholder": "Enter your full name"
                },
                {
                    "label": "Address",
                    "name": "11-address",
                    "required": true,
                    "type": "text",
                    "placeholder": "Enter your address"
                },
                {
                    "label": "Telephone number",
                    "name": "12-phone",
                    "required": false,
                    "type": "tel",
                    "placeholder": "Enter your telephone number (optional)"
                },
                {
                    "label": "Email",
                    "name": "13-email",
                    "required": true,
                    "type": "email",
                    "placeholder": "Enter your email"
                },
                {
                    "label": "Do you represent an organisation? If so, which one?",
                    "name": "14-organisation",
                    "required": false,
                    "type": "text",
                    "placeholder": "Enter organisation (optional)"
                },
                {
                    "label": "Do you wish to be kept updated on the project?",
                    "name": "15-progress",
                    "required": true,
                    "type": "radio",
                    
                    "options": [
                        {
                            "label": "Yes",
                            "value": "yes"
                        },
                        {
                            "label": "No",
                            "value": "no"
                        }
                    ]
                },
            ]
        }
    ],
};
